/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmr_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`At a moderate activity level his TDEE is ~2760 kcal.`)
};

const es_bmr_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con un nivel de actividad moderado, su GEDT es de ~2760 kcal.`)
};

const de_bmr_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei moderatem Aktivitätslevel liegt sein TDEE bei ~2760 kcal.`)
};

const nl_bmr_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bij een matig activiteitsniveau is zijn TDEE ~2760 kcal.`)
};

const fr_bmr_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avec un niveau d'activité modéré, son TDEE est d'environ 2760 kcal.`)
};

const it_bmr_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con un livello di attività moderato il suo TDEE è di circa 2760 kcal.`)
};

const pt_br2_bmr_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Com nível de atividade moderado, seu GET fica em ~2760 kcal.`)
};

const pt_bmr_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Com um nível de atividade moderado, o seu TDEE é de ~2760 kcal.`)
};

const ja_bmr_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`適度な活動レベルの場合、TDEEは約2760kcalです。`)
};

const zh_bmr_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在中度活动水平下，他的 TDEE 约为 2760 千卡。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmr_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmr_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmr_ex2", locale)
	if (locale === "en") return en_bmr_ex2(inputs)
	if (locale === "es") return es_bmr_ex2(inputs)
	if (locale === "de") return de_bmr_ex2(inputs)
	if (locale === "nl") return nl_bmr_ex2(inputs)
	if (locale === "fr") return fr_bmr_ex2(inputs)
	if (locale === "it") return it_bmr_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_bmr_ex2(inputs)
	if (locale === "pt") return pt_bmr_ex2(inputs)
	if (locale === "ja") return ja_bmr_ex2(inputs)
	return zh_bmr_ex2(inputs)
};